import { Component, Input } from '@angular/core';
import { IconGeneralIcon } from '@inshared/website-ui-components';

@Component({
    selector: 'ins-cancel-insurance-list-product',
    templateUrl: 'cancel-insurance-list-product.component.html',
    styleUrls: [ 'cancel-insurance-list-product.component.scss' ],
})
export class CancelInsuranceListProductComponent {
    @Input() public icon!: IconGeneralIcon;
}
